var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"flex items-center"},[_c('input',{staticClass:"form-radio h-5 w-5",attrs:{"type":"radio","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"input":_vm.onSelect}}),_c('div',{staticClass:"ms-2"},[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.label))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }